import React from 'react';
import { Box, FormControlLabel, Switch, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { fmtMoney, fmtNumber } from '../../utils/format';

/**
 * Totals of a quote or pro-forma invoice. Prices are without PDV and PDV is added on top (server: model/Vat):
 * with PDV it shows the base, the PDV and the total to pay; without PDV one total marked "without PDV".
 * `doc` has net, vatEnabled, vatRate, vatAmount, total. `onToggle(on)` adds the "with PDV" switch.
 */
export default function VatTotals({ doc, fmt = fmtMoney, onToggle, disabled }) {
    const { t } = useTranslation();
    const rate = fmtNumber(doc.vatRate);
    const line = (label, value, strong) => (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'baseline', gap: 3 }}>
            <Typography sx={{ fontSize: strong ? 14 : 13, fontWeight: strong ? 700 : 500, color: strong ? '#0F172A' : '#64748B' }}>{label}</Typography>
            <Typography sx={{ fontSize: strong ? 18 : 14, fontWeight: strong ? 800 : 600, color: strong ? '#427898' : '#0F172A', minWidth: 120, textAlign: 'right', whiteSpace: 'nowrap' }}>
                {value}
            </Typography>
        </Box>
    );
    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', justifyContent: 'space-between', gap: 1.5 }}>
            <Box>
                {onToggle && (
                    <FormControlLabel disabled={disabled}
                                      control={<Switch size="small" checked={!!doc.vatEnabled} onChange={(e) => onToggle(e.target.checked)} />}
                                      label={<Typography sx={{ fontSize: 13.5 }}>{t('vat.withVat', { rate })}</Typography>} />
                )}
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, ml: 'auto' }}>
                {doc.vatEnabled ? (
                    <>
                        {line(t('vat.base'), fmt(doc.net))}
                        {line(t('vat.vat', { rate }), fmt(doc.vatAmount))}
                        {line(t('vat.totalToPay'), fmt(doc.total), true)}
                    </>
                ) : line(t('vat.totalNoVat'), fmt(doc.net), true)}
            </Box>
        </Box>
    );
}
